import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import AuthModal from "../../components/auth/AuthModal";
import GatewayTopNav from "../../components/dashboard/GatewayTopNav";
import GatewaySidebar from "../../components/dashboard/GatewaySidebar";
import QuestDashboardView from "../../components/quests/QuestDashboardView";
import { NOINDEX_PRIVATE_SEO } from "../../constants/siteSeo";
import { usePageSeo } from "../../hooks/usePageSeo";
import "./treydora-gateway-dashboard.css";
import "./quests-dashboard.css";

export default function QuestsPage() {
  const { loading, isAuthenticated } = useAuth();
  const [authOpen, setAuthOpen] = useState(false);

  usePageSeo({
    ...NOINDEX_PRIVATE_SEO,
    title: "Quests of Treydora | Treydora",
    description: "Trials, lore, relics, and your path through the world of Treydora.",
  });

  if (loading) {
    return (
      <div className="dashboard-shell dashboard-shell--loading">
        <p className="dg-hud">Loading quests…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="dashboard-shell dashboard-shell--gateway">
        <div className="dashboard-gate dg-gold-ring">
          <h1 className="dashboard-gate__title serif">Quests of Treydora</h1>
          <p className="dashboard-gate__lead">
            Sign in to open your trials, streaks, and oracle paths. This preview uses mock quest data until live
            progression ships.
          </p>
          <button type="button" className="dg-btn dg-btn--primary" onClick={() => setAuthOpen(true)}>
            Sign In
          </button>
        </div>
        <AuthModal isOpen={authOpen} onClose={() => setAuthOpen(false)} />
      </div>
    );
  }

  return (
    <div className="dashboard-shell dashboard-shell--gateway">
      <GatewayTopNav />
      <div className="dashboard-body dg-gateway-atmosphere">
        <GatewaySidebar />
        <div className="dashboard-workpad">
          <QuestDashboardView />
        </div>
      </div>
      <AuthModal isOpen={authOpen} onClose={() => setAuthOpen(false)} />
    </div>
  );
}
